import { Input } from "@/components/ui/input";

const mask = (raw) => {
  const d = raw.replace(/\D/g, "").slice(0, 12);
  let out = [d.slice(0, 2), d.slice(2, 4), d.slice(4, 8)].filter(Boolean).join(" ");
  if (d.length > 8) out += ` ${d.slice(8, 10)}`;
  if (d.length > 10) out += `:${d.slice(10, 12)}`;
  return out;
};

export const DateTimeInput = ({ value, onChange, invalid, ...props }) => (
  <Input value={value} onChange={(e) => onChange(mask(e.target.value))} inputMode="numeric" placeholder="DD MM YYYY JJ:MM"
    className={`h-11 bg-white tabular-nums tracking-[0.08em] ${invalid ? "border-red-400 focus-visible:ring-red-300" : ""}`} {...props} />
);
